/*
 * @Author: cc
 * @Date: 2019-11-25 12:52:27
 * @LastEditTime: 2020-07-13 19:12:59
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\planningResource\planningResource.js
 * @Description: 
 */ 
/**
 * 描述：策划资源
 * 日期：2017-8-17
 * 描述：Bai.Zhiming
 */
'use strict';
angular.module('planningResourceModule', ['planningResourceRouterModule', 'planningResourceLeftModule', 'commandMonitorModule']);
